<article class="grid-wrapper">
  @if (loading()) {
  <div class="state-row">
    <div class="spinner-wrapper">
      <app-spinner size="m" type="ripple" />
      <p>{{ 'pages.profiles.states.loading' | translate }}</p>
    </div>
  </div>
  } @else if (profiles().length === 0) {
  <div class="state-row">
    <span>{{ 'pages.profiles.states.empty' | translate }}</span>
  </div>
  } @else {
  <app-responsive-table
    [items]="profiles()"
    [columns]="columns()"
    [actions]="actions()"
    [maxInlineActions]="3"
    [trackBy]="trackByProfile"
    (actionSelected)="onActionSelected($event)"
    [paginated]="true"
    [page]="pageNumber()"
    [pageSize]="pageSize()"
    [totalItems]="totalItems()"
    (pageChange)="onPageChange($event)"
  />
  }
</article>
